import React from "react";
import PaymentBanner from "../components/Banner/PaymentBanner";
import Admin from "../components/Features/Admin";
import Service from "../components/Service/Service";
import Subscribe from "../components/Subscribe";
import SecurityFeatures from "../components/Missions/SecurityFeatures";
import Video from "../components/Video/Video";
import Footer from "../components/Footer/Footer";
import FooterData from "../components/Footer/FooterData";
import { trackEvent, PageEventName } from "../services/analytics";
import Associate from "../components/Features/Associate";
import EventPrice from "../components/EventPrice";
import EventFeatures from "../components/Event/EventFeatures";

export const Home = () => {
  React.useEffect(() => {
    trackEvent(PageEventName.Home);
  }, []);

  return (
    <div className="body_wrapper">
      <PaymentBanner />
      <Associate />
      <EventPrice />
      <SecurityFeatures />
      <EventFeatures />
      <Video />
      <Admin />
      <Service />
      <Subscribe />
      <Footer FooterData={FooterData} />
    </div>
  );
};
